import { BaseElements, BaseObject, BaseService, BaseInjector } from '../../../js/base';
import { EmptyNodeList, querySelectorAll, querySelector } from '../../../utility/utils/index';

class Texts extends BaseObject { }

class ClassList extends BaseObject {
    displayNone = 'd-none';
    displayFlex = 'd-flex';
    iconEye = 'icon-eye';
    iconEyeOff = 'icon-eye-off';
}

class Selectors extends BaseObject {
    input = 'input';
    passwordInput = '[type="password"]';
    eyeElement = '[class^="icon-eye"], [class*=" icon-eye"]';
}


class Elements extends BaseElements<Selectors> {
    passwordInputs: NodeListOf<HTMLElement> = new EmptyNodeList;

    constructor(selectors: Selectors) {
        super(selectors, true);
    }

    initElements() {
        this.passwordInputs = querySelectorAll(this.selectors.passwordInput);
    }
}

interface ShowPassword extends BaseService<Selectors, Elements, ClassList, Texts> { }

@BaseInjector(Selectors, Elements, ClassList, Texts)
class ShowPassword {

    initialize(): void {
        if (!this.elements.passwordInputs.length) {
            return;
        }
        this.addEventListeners();
    }

    addEventListeners(): void {
        this.elements.passwordInputs.forEach(passwordInput => {
            passwordInput.addEventListener('input', this.onChangePassword.bind(this));
            const eye = querySelector(this.selectors.eyeElement, passwordInput.parentElement);
            if (eye) {
                eye.addEventListener('click', this.onEyeClick.bind(this));
            }
        });
    }

    onChangePassword(event) {
        const _this = event.target; // input field
        querySelector(this.selectors.eyeElement, _this.parentElement)?.classList.toggle(this.classList.displayNone, !_this.value);
    }
    onEyeClick(event) {
        const _this = event.target; // icon eye
        const input = querySelector(this.selectors.input, _this.parentElement);
        _this.classList.toggle(this.classList.iconEye);
        _this.classList.toggle(this.classList.iconEyeOff);
        input.setAttribute('type', 'password');
        if (_this.classList.contains(this.classList.iconEyeOff)) {
            input.setAttribute('type', 'text');
        }
    }

}

export default ShowPassword;

export {
    Elements as ShowPasswordElements,
    Selectors as ShowPasswordSelectors,
    ClassList as ShowPasswordClassList,
    Texts as ShowPasswordTexts
}